import { DirectiveEditMode } from '@pushly/models/lib/types/pushly-ai/directive-edit-mode'
import { GenerationFallbackMode } from '@pushly/models/lib/types/pushly-ai/generation-fallback-mode'

/**
 * Client-side (camelCase) view of the server's `AiGenerationPolicy` struct (NS-2649).
 *
 * The policy is stored on the domain (`domains.ai_generation_policy`) and saved via
 * the standard domain PATCH, whose axios interceptors bridge camelCase <-> the
 * server's snake_case (mirroring `IDomainEcommConfig`). The union *values*
 * (e.g. `append_only`) are wire strings and pass through unchanged.
 *
 * NOTE: the AI generation *directive* CRUD is handled by `AiGenerationDirectiveService`
 * using the `@pushly/models` structs directly (snake-case, `skipCaseConversion`), so no
 * client-side directive interface is needed here.
 */
export interface IAiGenerationPolicy {
    directiveEditMode: DirectiveEditMode
    fallbackMode: GenerationFallbackMode
    brandVoicePreview: boolean
    allowInlineVoiceEdit: boolean
    requireDirective: boolean
}

/** Governance-preserving defaults (mirror the server-side struct defaults). */
export const DEFAULT_AI_GENERATION_POLICY: IAiGenerationPolicy = {
    directiveEditMode: 'append_only',
    fallbackMode: 'instruction_only',
    brandVoicePreview: true,
    allowInlineVoiceEdit: false,
    requireDirective: false,
}
